export default __webpack_public_path__ + "static/media/design-tool-logo.7a2d282d.png";